<!-- <div class="d-flex flex-fill"> -->
<div class="d-flex flex-fill flex-column pb-3">
  <div class="d-flex flex-row header-row">
    <div class="d-flex flex-column col-sm-3">
      <div class="d-flex flex-row">
        <button class="btn btn-sm btn-primary" (click)="new()">New</button>
        <button class="btn btn-sm btn-primary ms-2" (click)="new(true)">Copy</button>
        <button class="ms-2 btn btn-sm btn-primary" (click)="editCommitteeAttachment()" [disabled]="dataGrid?.instance.getSelectedRowsData().length === 0">Edit</button>
        <button class="ms-2 btn btn-sm btn-danger" (click)="delete()" [disabled]="dataGrid?.instance.getSelectedRowsData().length === 0">Delete</button>
      </div>
    </div>
    <div class="d-flex flex-column">
      <h3 class="title-font">
        {{ selectedAgenda ? selectedAgenda.name : "" }}
      </h3>
    </div>
  </div>
  <div class="d-flex flex-fill">
    @if (documents) {
      <div class="d-flex flex-column agenda-data-grid col-sm-3">
        <dx-data-grid
          #dataGrid
          [dataSource]="documents"
          keyExpr="id"
          class="flex-fill"
          [showBorders]="true"
          [columnAutoWidth]="false"
          [focusedRowEnabled]="false"
          [showColumnLines]="true"
          [wordWrapEnabled]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onSelectionChanged)="onSelectionChanged($event)"
          (onCellDblClick)="rowDoubleClick($event)"
          (onRowPrepared)="rowPrepare($event)"
          >
          <dxi-column dataField="created" caption="Date" dataType="date" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
          <dxi-column dataField="name" width="500"></dxi-column>
          <dxo-state-storing [enabled]="true" type="localStorage" storageKey="agenda-grid"></dxo-state-storing>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-search-panel [visible]="false"></dxo-search-panel>
          <dxo-selection [mode]="'single'" showCheckBoxesMode="true"></dxo-selection>
          <div *dxTemplate="let data of 'toolbarButtons'"></div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (documents) {
              <span class="me-3">
                <strong>{{ dataGrid.instance.totalCount() + " items" }}</strong>
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
    }
    <div class="d-flex flex-fill flex-column ark-html-editor-padding pb-3">
      <div class="agenda-btn-toolbar">
        <!-- <button class="btn btn-primary" (click)="new()">New</button> -->
        <button class="btn btn-primary" (click)="email()" [disabled]="!canEmail">Email</button>
        <!-- <button class="ms-2 btn btn-primary" (click)="submit()" [disabled]="true">Submit</button> -->
        @if (hasChanges()) {
          <button class="ms-2 btn btn-sm btn-success" (click)="save()" accesskey="s" title="alt+s">Save (alt+s)</button>
        }
        @if (hasChanges()) {
          <button class="ms-2 btn btn-sm btn-danger" (click)="cancel()">Cancel</button>
        }
      </div>
      <div class="d-flex">
        @if (selectedAgenda) {
          <dx-html-editor
            #editor
            class="ark-html-editor"
            valueType="'html'"
            [height]="'800px'"
            [(value)]="selectedAgenda.agendaText"
            [readOnly]="false"
            >
            <!-- this is for angular 9 -->
            <!-- <dxo-toolbar [items]="items"></dxo-toolbar> -->
            <!-- this is for angular 17 -->
            <dxo-toolbar>
              <dxi-item name="undo"></dxi-item>
              <dxi-item name="redo"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="header" [acceptedValues]="[1, 2, 3, false]" [options]="{ width: 200 }"></dxi-item>
              <dxi-item
                name="size"
                [acceptedValues]="['8pt', '10pt', '11pt', '12pt', '14pt', '18pt', '24pt', '36pt', '72pt']"
                            [options]="{
                                inputAttr: { 'aria-label': 'Font size' }
                            }"
              ></dxi-item>
              <dxi-item
                name="font"
                [acceptedValues]="['Arial', 'Calibri', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana']"
                            [options]="{
                                inputAttr: { 'aria-label': 'Font family' }
                            }"
              ></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="color"></dxi-item>
              <dxi-item name="background"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="bold"></dxi-item>
              <dxi-item name="italic"></dxi-item>
              <dxi-item name="strike"></dxi-item>
              <dxi-item name="underline"></dxi-item>
              <dxi-item name="superscript"></dxi-item>
              <dxi-item name="subscript"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="alignLeft"></dxi-item>
              <dxi-item name="alignCenter"></dxi-item>
              <dxi-item name="alignRight"></dxi-item>
              <dxi-item name="alignJustify"></dxi-item>
              <dxi-item name="increaseIndent"></dxi-item>
              <dxi-item name="decreaseIndent"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="insertTable"></dxi-item>
              <dxi-item name="deleteTable"></dxi-item>
              <dxi-item name="insertRowAbove"></dxi-item>
              <dxi-item name="insertRowBelow"></dxi-item>
              <dxi-item name="deleteRow"></dxi-item>
              <dxi-item name="insertColumnLeft"></dxi-item>
              <dxi-item name="insertColumnRight"></dxi-item>
              <dxi-item name="deleteColumn"></dxi-item>
              <dxi-item name="cellProperties"></dxi-item>
              <dxi-item name="tableProperties"></dxi-item>
            </dxo-toolbar>
            <dxo-table-context-menu [enabled]="true"> </dxo-table-context-menu>
          </dx-html-editor>
        }
      </div>
    </div>
  </div>
</div>
<!-- </div> -->
